import React from "react";
import styled from "styled-components";
import { StyledSubmitButton } from "./StyledButton";
import { ClipLoader } from "react-spinners";
import { FormattedMessage } from "react-intl";

const Button = styled(StyledSubmitButton)``;

const SubmitButton = ({ onSubmit, submitted, submitting, disabled, error }) => (
  <Button
    onClick={() => onSubmit()}
    disabled={submitted || submitting || disabled}
  >
    {submitting ? (
      <ClipLoader size={25} />
    ) : (
      <span>
        <FormattedMessage id="globals.submit" />
      </span>
    )}
  </Button>
  // error?
);

export default SubmitButton;
